import { render, staticRenderFns } from "./CourseExamQuestionOptionForm.vue?vue&type=template&id=266499f1"
import script from "./CourseExamQuestionOptionForm.vue?vue&type=script&lang=ts"
export * from "./CourseExamQuestionOptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports